import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { logger } from "../logger";
import { fireEvents } from "../utils/fireEvents";
import { getMetricAttrs, getMetricNodes } from "../utils/getMetricAttrs";

/* Класс для создания MutationObserver */
var MetricObserver = /*#__PURE__*/function () {
  // eslint-disable-next-line sonarjs/cognitive-complexity
  function MetricObserver(helpers) {
    var _this = this;
    _classCallCheck(this, MetricObserver);
    _defineProperty(this, "list", new Map());
    _defineProperty(this, "helpers", void 0);
    _defineProperty(this, "observer", void 0);
    _defineProperty(this, "handler", function (_, names, data) {
      fireEvents(names, _this.helpers, data);
    });
    _defineProperty(this, "applyIntersection", function (element) {
      var _getMetricAttrs = getMetricAttrs(element),
        viewportThreshold = _getMetricAttrs.viewportThreshold,
        name = _getMetricAttrs.name;
      if (typeof window !== 'undefined' && window.IntersectionObserver) {
        var observer = new IntersectionObserver(_this.intersectionHandler, {
          threshold: viewportThreshold
        });
        logger.debug("Intersection observer observe, name: ".concat(name), ['Element:', element], ['Config', getMetricAttrs(element)]);
        observer.observe(element);
        _this.list.set(element, observer);
      }
    });
    _defineProperty(this, "handleMount", function (element) {
      var _getMetricAttrs2 = getMetricAttrs(element),
        mode = _getMetricAttrs2.mode,
        name = _getMetricAttrs2.name,
        data = _getMetricAttrs2.data;
      if (mode === 'viewport') _this.applyIntersection(element);
      if (mode === 'render') {
        _this.handler('render', name, data);
        logger.debug("Trigger: ".concat(mode, ", name: ").concat(name), ['Element:', element], ['Config', getMetricAttrs(element)]);
      }
    });
    _defineProperty(this, "handleUnmount", function (element) {
      var _getMetricAttrs3 = getMetricAttrs(element),
        mode = _getMetricAttrs3.mode,
        name = _getMetricAttrs3.name,
        data = _getMetricAttrs3.data;
      if (mode === 'unmount') {
        _this.handler(mode, name, data);
        logger.debug("Trigger: ".concat(mode, ", name: ").concat(name), ['Element:', element], ['Config', getMetricAttrs(element)]);
      }
      _this.cancelIntersection(element);
    });
    _defineProperty(this, "cancelIntersection", function (element) {
      var intersectionObserver = _this.list.get(element);
      if (intersectionObserver) {
        logger.debug('Intersection observer disconnect', ['Element:', element], ['Config', getMetricAttrs(element)]);
        intersectionObserver.disconnect();
        _this.list.delete(element);
      }
    });
    _defineProperty(this, "intersectionHandler", function (entries, observer) {
      entries.forEach(function (entry) {
        var _getMetricAttrs4 = getMetricAttrs(entry.target),
          viewportOnce = _getMetricAttrs4.viewportOnce,
          name = _getMetricAttrs4.name,
          mode = _getMetricAttrs4.mode,
          _getMetricAttrs4$data = _getMetricAttrs4.data,
          data = _getMetricAttrs4$data === void 0 ? '' : _getMetricAttrs4$data;
        if (entry.isIntersecting) {
          if (viewportOnce) {
            logger.debug('Intersection observer unobserve', ['Element:', entry.target], ['Config', getMetricAttrs(entry.target)]);
            observer.unobserve(entry.target);
          }
          logger.debug("Trigger: ".concat(mode, ", name: ").concat(name), ['Element:', entry.target], ['Config', getMetricAttrs(entry.target)]);
          _this.handler('viewport', name, data);
        }
      });
    });
    this.helpers = helpers;
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      var metricNodes = getMetricNodes(document);
      logger.debug.apply(logger, ["MetricObserver started. Found: ".concat(metricNodes.length, " nodes")].concat(_toConsumableArray(metricNodes.map(function (node) {
        return [node, getMetricAttrs(node)];
      }))));
      metricNodes.forEach(this.handleMount);
      if (window.MutationObserver) {
        this.observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            var addedNodes = mutation.addedNodes,
              removedNodes = mutation.removedNodes;
            addedNodes.forEach(function (node) {
              if (node instanceof HTMLElement) {
                getMetricNodes(node).forEach(_this.handleMount);
              }
            });
            removedNodes.forEach(function (node) {
              if (node instanceof HTMLElement) {
                getMetricNodes(node).forEach(_this.handleUnmount);
              }
            });
          });
        });
        logger.debug('Global mutation observer started');
        this.observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  }
  _createClass(MetricObserver, [{
    key: "disconnect",
    value: function disconnect() {
      var _this$observer;
      (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.disconnect();
      this.list.forEach(function (observer) {
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
      });
      this.list.clear();
    }
  }]);
  return MetricObserver;
}();
export default MetricObserver;